import {Dialog, Pane, Paragraph} from 'evergreen-ui';
import React, {memo, useCallback} from 'react';
import {BehaviorSubject} from 'rxjs';

import {useObservable} from '../../../rxsupport';

type Props = {
    show$: BehaviorSubject<boolean>;
    messages: String[];
    onConfirmed: () => any;
}

const WIDTH = 600;

export const SlaConfirmationDialog =
    memo(function SlaConfirmationDialog({
                                            messages,
                                            show$,
                                            onConfirmed,
                                        }: Props) {
        const show = useObservable(show$, false);
        const onClose = useCallback(() => {
            show$.next(false);
        }, [show$]);

        return (
            <Dialog
                title="Match Provider"
                isShown={show}
                width={WIDTH}
                hasClose={false}
                onCloseComplete={onClose}
                contentContainerProps={{
                    textAlign: 'center',
                    justifyContent: 'center'
                }}
                footer={({close}) => (<>
                    {/* minus the default evergreen-ui padding in footer container */}
                    <Pane width={WIDTH - 16 * 2} className="flex justify-center">
                        <button
                            autoFocus
                            className="px-5 py-2 mr-5 focus:outline-none"
                            onClick={close}
                            style={{
                                backgroundColor: '#FFF',
                                color: '#00AB93',
                                borderColor: '#00AB93',
                                border: '1px solid'
                            }}
                        >
                            Cancel
                        </button>
                        <button
                            className="px-5 py-2"
                            onClick={onConfirmed}
                            style={{
                                backgroundColor: '#00AB93',
                                color: '#FFF'
                            }}
                        >
                            Yes, Match
                        </button>
                    </Pane>
                </>)}
            >
                <Paragraph style={{color: '#707070'}} size={500}>
                    Selected offer {messages.filter((message) => message !== "").join(", ")}. <b>Do you want to
                    proceed with selection?</b>
                </Paragraph>

            </Dialog>
        );
    });
